import React from 'react';

// Static fields that are always available (excluding custom fields)
const STATIC_FIELDS = [
  { id: 'year', label: 'Year' },
  { id: 'denomination', label: 'Denomination' },
  { id: 'mint_mark', label: 'Mint Mark' },
  { id: 'variety', label: 'Variety' },
  { id: 'minor_variety', label: 'Minor Variety' },
  { id: 'die_variety', label: 'Die Variety' },
  { id: 'grade', label: 'Grade' },
  { id: 'certification_service_id', label: 'Certification Service' },
  { id: 'certification_number', label: 'Certification Number' },
  { id: 'mintage', label: 'Mintage' },
  { id: 'price_guide_value', label: 'Price Guide Value' },
  { id: 'purchase_date', label: 'Purchase Date' },
  { id: 'purchase_price', label: 'Purchase Price' },
  { id: 'shipping_cost', label: 'Shipping Cost' },
  { id: 'grading_cost', label: 'Grading Cost' },
  { id: 'total_cost', label: 'Total Cost' },
  { id: 'notes', label: 'Notes' },
  { id: 'population_when_bought', label: 'Population When Bought' },
  { id: 'current_population', label: 'Current Population' },
  { id: 'pop_higher_when_bought', label: 'Pop Higher When Bought' },
  { id: 'current_pop_higher', label: 'Current Pop Higher' },
  { id: 'pcgs_number', label: 'PCGS Number' },
  { id: 'country', label: 'Country' },
  { id: 'metal', label: 'Metal' },
  { id: 'composition', label: 'Composition' },
  { id: 'provenance', label: 'Provenance' },
  { id: 'weight', label: 'Weight' },
  { id: 'diameter', label: 'Diameter' },
  { id: 'edge', label: 'Edge' },
  { id: 'list_price', label: 'List Price' },
  { id: 'storage_location', label: 'Storage Location' },
  { id: 'reference_number', label: 'Reference Number' },
  { id: 'assayer', label: 'Assayer' },
  { id: 'cac_sticker', label: 'CAC Sticker' },
  { id: 'coin_details', label: 'Coin Details' }
];

const FieldSelector = ({ selectedFields, onChange, className = '', customFields = [] }) => {
  const handleToggleField = (field) => {
    // Don't allow unchecking required fields
    if (field.required && selectedFields.includes(field.id)) {
      return;
    }

    if (selectedFields.includes(field.id)) {
      onChange(selectedFields.filter(id => id !== field.id));
    } else {
      onChange([...selectedFields, field.id]);
    }
  };

  // Required fields that should always be shown at the top
  const requiredFields = [
    { id: 'year', label: 'Year', required: true },
    { id: 'denomination', label: 'Denomination', required: true }
  ];

  // Get all other fields and sort them alphabetically
  const optionalFields = [
    ...STATIC_FIELDS.filter(field => !['year', 'denomination'].includes(field.id)),
    ...customFields.map(field => ({
      id: `custom_field_${field.id}`,
      label: field.name,
      isCustom: true
    }))
  ].sort((a, b) => a.label.localeCompare(b.label));

  const allFields = [...requiredFields, ...optionalFields];

  return (
    <div className={`border border-gray-300 rounded-md p-2 ${className}`}>
      <div className="space-y-2">
        {/* Required Fields */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
          {requiredFields.map(field => (
            <label key={field.id} htmlFor={`field-${field.id}`} className="inline-flex items-center">
              <input
                type="checkbox"
                id={`field-${field.id}`}
                name={`field-${field.id}`}
                checked={selectedFields.includes(field.id)}
                onChange={() => handleToggleField(field)}
                className="form-checkbox h-4 w-4 text-indigo-600 rounded"
                disabled={field.required && selectedFields.includes(field.id)}
              />
              <span className="ml-2 text-sm font-medium text-gray-900">
                {field.label}<span className="text-red-500 ml-0.5">*</span>
              </span>
            </label>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200" />

        {/* Optional Fields */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {optionalFields.map(field => (
          <label key={field.id} htmlFor={`field-${field.id}`} className="inline-flex items-center">
            <input
              type="checkbox"
              id={`field-${field.id}`}
              name={`field-${field.id}`}
              checked={selectedFields.includes(field.id)}
              onChange={() => handleToggleField(field)}
              className="form-checkbox h-4 w-4 text-indigo-600 rounded"
            />
            <span className={`ml-2 text-sm ${field.isCustom ? 'text-indigo-600' : 'text-gray-700'}`}>
              {field.label}
            </span>
          </label>
        ))}
        </div>
      </div>
    </div>
  );
};

export default FieldSelector;
